import React, { Fragment, useEffect, useState } from "react";
import { get_shared_users_list } from "../../../../../store/actions/SuperAdminActions/adminShortVideosAction";
import { useDispatch } from "react-redux";
import { Modal } from "react-bootstrap";

export const ListOfSharesView = (props) => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [sharesData, setSharesData] = useState([]);

  const colors = ["#FF5733", "#FFC300", "#C70039", "#900C3F", "#581845"];
  const callAction = async () => {
    if (props?.data?.shares > 0) {
      setSharesData(
        await dispatch(
          await get_shared_users_list(
            props?.data?._id,
            props?.auth?.user?.accessToken
          )
        )
      );
      setShowModal(true);
    }
  };
  return (
    <Fragment>
      <div
        className={` f12-500 ${
          props?.data?.shares > 0 ? "text-info cursor-pointer" : "text-secondary"
        }`}
        onClick={callAction}
      >
        Shares
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <div className="f18-500">Shares</div>
        </Modal.Header>
        <Modal.Body className="f16-500">
          {sharesData?.map((like, index) => {
            return (
              <div className="row m-3 align-items-center">
                <div className="col-1 p-0">
                  {like?.profilePicture !== "" ? (
                    <img
                      src={like?.profilePicture}
                      className="image-circle"
                      style={{
                        height: "40px",
                        width: "40px",
                      }}
                    />
                  ) : (
                    <>
                      <div
                        className="rounded-circle justify-content-center d-flex align-items-center"
                        style={{
                          backgroundColor: colors[index],
                          height: "40px",
                          width: "40px",
                          color: "white",
                        }}
                      >
                        {like?.name[0].toUpperCase()}
                      </div>
                    </>
                  )}
                </div>
                <div className="col-11">{like?.name}</div>
              </div>
            );
          })}
        </Modal.Body>
      </Modal>
    </Fragment>
  );
};
